// extracted by mini-css-extract-plugin
export default {"container":"LZ-z","heading":"MZ-z","links":"NZ-z","copy":"OZ-z","subCopy":"PZ-z","linksLeft":"QZ-z","linksCenter":"RZ-z","linksRight":"SZ-z","link":"TZ-z","onlyLink":"UZ-z"};